/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import CriticalJobsWidget from "../../../widgets/CriticalJobsWidget/CriticalJobsWidget";
import { BackgroundPanel, TableAdvanced } from "vr-react-components";
import { getFormattedTime } from "../../../utils/TimeUtils";
import { useSelector } from "react-redux";
import { handleSetKeyboard } from "../../../handlers/PrivateHandlers";

const RightPanelVR = React.memo(({ width, height }) => {
    const criticalJobs = useSelector((state) => state.workstationroom.criticalJobsData);
    const canModify = useSelector((state) => state.private.device.canModify);
    
    let criticalJobsData = [];
    if (criticalJobs)
        Object.keys(criticalJobs).forEach((elem) => {
            criticalJobsData = [...criticalJobsData, ...criticalJobs[elem]];
        });
    const innerWidth = (width / 2) * 0.9;
    const innerHeight = height * 0.9;
    const padding = innerWidth / 50;
    const textSize = 45 / innerWidth;

    return (
        <>
            <BackgroundPanel
                width={width / 2}
                height={height}
                position={`${width / 4} 0 0`}
                rotation={"0 -30 0"}
            >
                <CriticalJobsWidget
                    width={innerWidth - padding}
                    height={innerHeight / 2 - padding}
                    position={`0 ${height / 2 - innerHeight / 4 - height * 0.05} 0.001`}
                    textSizeDecimal={textSize}
                />
                <TableAdvanced
                    width={innerWidth - padding}
                    height={innerHeight / 2 - padding}
                    position={`0 ${-padding * 3} 0.001`}
                    aframeClasses={canModify ? "collidable" : ""}
                    keyboardHandler={(type, visible, callback) => {
                        handleSetKeyboard(type, visible, callback)
                    }}
                    search
                    data={[
                        ["Name", "Risk", "Jobstream", "Scheduled Time"],
                        ...criticalJobsData.map((x) => [
                            x.name,
                            x.risk,
                            x.workflow,
                            getFormattedTime(x.scheduledTime),
                        ]),
                    ]}
                />
            </BackgroundPanel>
        </>
    );
});

export default RightPanelVR;
